var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.540829 10.7559C1.99588 6.52833 6.1377 3.5 11 3.5C15.8623 3.5 20.0041 6.52833 21.4592 10.7559C21.5136 10.9141 21.5136 11.0859 21.4592 11.2441C20.0041 15.4717 15.8623 18.5 11 18.5C6.1377 18.5 1.99588 15.4717 0.540829 11.2441C0.48639 11.0859 0.48639 10.9141 0.540829 10.7559ZM2.04727 11C3.3631 14.4826 6.85943 17 11 17C15.1406 17 18.6369 14.4826 19.9527 11C18.6369 7.51743 15.1406 5 11 5C6.85943 5 3.3631 7.51743 2.04727 11Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8ZM6.5 11C6.5 8.51472 8.51472 6.5 11 6.5C13.4853 6.5 15.5 8.51472 15.5 11C15.5 13.4853 13.4853 15.5 11 15.5C8.51472 15.5 6.5 13.4853 6.5 11Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.71967 0.71967C1.01256 0.426777 1.48744 0.426777 1.78033 0.71967L21.2803 20.2197C21.5732 20.5126 21.5732 20.9874 21.2803 21.2803C20.9874 21.5732 20.5126 21.5732 20.2197 21.2803L0.71967 1.78033C0.426777 1.48744 0.426777 1.01256 0.71967 0.71967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCross);
export default __webpack_public_path__ + "static/media/eye-cross.f4a8e7d04f6e86e074602ca96278485e.svg";
export { ForwardRef as ReactComponent };